import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const root = (theme: Theme) => css`
  /* needs to be relative to render chevron over <select></select> */
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: solid 1px ${theme.palette.neutral[300]};
  padding: 0 0 ${size[4]};

  ${breakpoint.up('md')} {
    padding: ${size[4]} 0 ${size[8]};
  }

  option {
    color: ${theme.palette.neutral[900]};
    background-color: ${theme.palette.background.primary};
  }
`

export const focused = (theme: Theme) => css`
  border-bottom-color: ${theme.palette.brand[500]};
  box-shadow: 0px 1px 0px 0px ${theme.palette.brand[500]};
`

export const error = (theme: Theme) => css`
  border-bottom-color: ${theme.palette.error[500]};
  box-shadow: 0px 1px 0px 0px ${theme.palette.error[500]};
`

export const select = (theme: Theme) => css`
  cursor: pointer;
  appearance: none;
  border: none;
  width: 100%;
  padding: 0;
  /* 16px to prevent ios zooming */
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: ${theme.palette.neutral[900]};
  caret-color: ${theme.palette.brand[500]};
  background-color: transparent;

  &::placeholder {
    color: ${theme.palette.neutral[700]};
    font-weight: 400;
  }

  &:disabled {
    opacity: 1; /* required on iOS */
    -webkit-text-fill-color: ${theme.palette
      .neutral[600]}; /* required on iOS */
    color: ${theme.palette.neutral[600]};
  }
`

export const chevron = (theme: Theme) => css`
  color: ${theme.palette.neutral[700]};
  position: absolute;
  right: 0;
  /* allow opening select */
  pointer-events: none;
`

export const startAdornment = css`
  margin-right: ${size[8]};
`
